/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationBar_viewer = {
    readonly broadcastNotifications: {
        readonly total: number | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
        };
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly read: {
                    readonly createdAt: string;
                } | null;
                readonly broadcast: {
                    readonly message: string;
                    readonly title: string;
                };
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "NotificationBar_viewer";
};
export type NotificationBar_viewer$data = NotificationBar_viewer;
export type NotificationBar_viewer$key = {
    readonly " $data"?: NotificationBar_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationBar_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "cancelled"
    },
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "delivered"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "expired"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "read"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": null,
        "direction": "forward",
        "path": [
          "broadcastNotifications"
        ]
      }
    ]
  },
  "name": "NotificationBar_viewer",
  "selections": [
    {
      "alias": "broadcastNotifications",
      "args": [
        {
          "kind": "Variable",
          "name": "cancelled",
          "variableName": "cancelled"
        },
        {
          "kind": "Variable",
          "name": "delivered",
          "variableName": "delivered"
        },
        {
          "kind": "Variable",
          "name": "expired",
          "variableName": "expired"
        },
        {
          "kind": "Variable",
          "name": "read",
          "variableName": "read"
        }
      ],
      "concreteType": "BroadcastNotificationConnection",
      "kind": "LinkedField",
      "name": "__NotificationBar_broadcastNotifications_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BroadcastNotificationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BroadcastNotification",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BroadcastNotificationRead",
                  "kind": "LinkedField",
                  "name": "read",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "createdAt",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Broadcast",
                  "kind": "LinkedField",
                  "name": "broadcast",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "message",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'c4dc104294a37073b98f971f955d7290';
export default node;
